"use client";

// Imports
import { useEffect, useState, useRef } from "react";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectValue,
} from "../../ui/select";
import { Selectors, FilterNav, FilterDrawer } from "@/components";
import { Button } from "@/components/ui/button";
import { Search, X } from "lucide-react";

// Filter Bar
export function FilterBar({
  categories,
  collectionHandle,
  searchParams,
  setSortBy,
  setSearchTerm,
  setActiveCategories,
  activeCategories,
  tagItems = [],
  setActiveTags,
  activeTags = [],
}) {
  // const { setSortBy, setSearchTerm, setActiveCategories, activeCategories } =
  //   useStore();
  const [searchWord, setSearchWord] = useState();
  const [showSearch, setShowSearch] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (searchWord == "") setSearchTerm("");
  }, [searchWord]);

  useEffect(() => {
    if (activeCategories?.length > 1) {
      setActiveCategories([activeCategories[0]]);
    }
  }, [activeCategories, setActiveCategories]);

  useEffect(() => {
    if (
      typeof setActiveTags === "function" &&
      activeTags?.length > 1
    ) {
      setActiveTags([activeTags[0]]);
    }
  }, [activeTags, setActiveTags]);

  function handleSubmit(e) {
    e.preventDefault();
    setSearchTerm(searchWord);
  }

  useEffect(() => {
    if (showSearch && inputRef.current) {
      inputRef.current.focus();
    } else if (inputRef.current) {
      inputRef.current.blur();
    }
  }, [showSearch]);

  function toggleSearch() {
    setShowSearch(!showSearch);
  }

  const redGumButtonStyle =
    collectionHandle === "competitions" ||
    collectionHandle === "rides" ||
    collectionHandle === "commercial_exhibitors" ||
    collectionHandle === "showbags" ||
    collectionHandle === "food_outlets"
      ? {
          // Red gum fills instead of saddle orange
          "--button-background": "137 33 2",
          "--button-hover-background": "137 33 2",
          "--button-foreground": "255 255 255",
        }
      : undefined;

  // Render
  return (
    <div
      className="flex flex-col items-start justify-between"
      style={redGumButtonStyle}
    >
      {tagItems?.length > 0 && typeof setActiveTags === "function" && (
        <FilterNav
          filterName="Tags"
          items={tagItems}
          setActiveItems={setActiveTags}
          activeItems={activeTags}
          singleSelect
          competitionTagStyle
        />
      )}
      <FilterNav
        filterName="Categories"
        items={categories}
        setActiveItems={setActiveCategories}
        activeItems={activeCategories}
        singleSelect
      />
      <div className="flex flex-col items-center justify-between w-full pb-6 lg:py-6 lg:flex-row">
        <div className="flex flex-row justify-end w-full gap-4 lg:flex-row">
          <FilterDrawer
            categories={categories}
            setActiveCategories={setActiveCategories}
            activeCategories={activeCategories}
            singleSelect
            tagItems={tagItems}
            setActiveTags={setActiveTags}
            activeTags={activeTags}
            tagSingleSelect
          />
          <form
            onSubmit={handleSubmit}
            className={`flex order-last relative lg:order-first animate-fade-in ${
              showSearch ? "hidden lg:flex" : "hidden"
            }`}
          >
            <input
              ref={inputRef}
              id="filter-search"
              className="w-full rounded-l-full border-2 border-brand-fawn pl-3 pr-6 text-base focus:outline-none lg:w-[300px]"
              onChange={(e) => setSearchWord(e.target.value)}
              value={searchWord}
              placeholder="Search..."
              type="text"
            />
            {searchWord?.length > 0 && (
              <button
                type="reset"
                className="absolute top-0 bottom-0 cursor-pointer right-24"
                onClick={() => setSearchWord("")}
              >
                <X />
              </button>
            )}
            <button
              className="px-4 text-base font-button font-semibold rounded-r-full h-11 bg-button text-button-foreground"
              type="submit"
            >
              Search
            </button>
          </form>
          <div className="flex justify-end w-full space-x-3 lg:w-auto">
            <Button onClick={() => toggleSearch()}>
              <Search size={24} />
            </Button>
            <div>
              <Select
                defaultValue={searchParams.get("sortBy") ?? "a-z"}
                onValueChange={(value) => setSortBy(value)}
              >
                <SelectTrigger
                  removeStyling={true}
                  asChild
                  className="justify-center w-full text-base text-center"
                >
                  <Button>
                    <SelectValue placeholder="Sort" />
                  </Button>
                </SelectTrigger>
                <SelectContent>
                  <Selectors collectionHandle={collectionHandle} />
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
        <form
          onSubmit={handleSubmit}
          className={`flex w-full mt-4 order-last relative lg:order-first animate-fade-in ${
            showSearch ? "lg:hidden" : "hidden"
          }`}
        >
          <input
            ref={inputRef}
            id="filter-search"
            className="w-full rounded-l-full border-2 border-brand-fawn pl-3 pr-6 text-base focus:outline-none lg:w-[300px]"
            onChange={(e) => setSearchWord(e.target.value)}
            value={searchWord}
            placeholder="Search..."
            type="text"
          />
          {searchWord?.length > 0 && (
            <button
              type="reset"
              className="absolute top-0 bottom-0 cursor-pointer right-24"
              onClick={() => setSearchWord("")}
            >
              <X />
            </button>
          )}
          <button
            className="px-4 text-base font-button font-semibold rounded-r-full h-11 bg-button text-button-foreground"
            type="submit"
          >
            Search
          </button>
        </form>
      </div>
    </div>
  );
}
